import { render } from "./FireNotesForm.vue?vue&type=template&id=0c5b2f9a&scoped=true"
import script from "./FireNotesForm.vue?vue&type=script&lang=ts"
export * from "./FireNotesForm.vue?vue&type=script&lang=ts"

import "./FireNotesForm.vue?vue&type=style&index=0&id=0c5b2f9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c5b2f9a"

export default script